import { render, staticRenderFns } from "./ClasificacionGenerosPorPopularidad.vue?vue&type=template&id=0a528651&"
import script from "./ClasificacionGenerosPorPopularidad.vue?vue&type=script&lang=js&"
export * from "./ClasificacionGenerosPorPopularidad.vue?vue&type=script&lang=js&"
import style0 from "./ClasificacionGenerosPorPopularidad.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports